import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Button, Col, Form, FormGroup, Input, Label } from "reactstrap";
import { EmailAddress, ForgotPassword, Password, RememberPassword, SignIn, SignInAccount } from "../../../../../constants";
import { LoginFormProp } from "../../../../../types/Others";
import CommonLogo from "./CommonLogo";
import SocialLinks from "./SocialLinks";
import { routes } from "../../../../../routers/routes";
import { useForm } from "react-hook-form";

const LoginForm: React.FC<LoginFormProp> = ({ logoClass }) => {
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const toggle = () => setPasswordVisible(!isPasswordVisible);
  const { register, handleSubmit, setValue, watch, reset, formState: { errors } } = useForm({ defaultValues: { email: "", password: "", checkbox1: false }});
  const formData = watch();
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value, type, checked } = e.target;
    setValue(id as keyof typeof formData, type === "checkbox" ? checked : value, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };
  const onSubmit = handleSubmit(() => {
    reset({ email: "", password: "", checkbox1: false });
  });
  
  return (
    <div>
      <div>
        <CommonLogo logoClass={logoClass} />
      </div>
      <div className="login-main">
        <Form className="theme-form" onSubmit={onSubmit}>
          <h4>{SignInAccount}</h4>
          <p>{"Enter your email & password to login"}</p>
          <FormGroup>
            <Col><Label>{EmailAddress}</Label></Col>
            <Input {...register("email", { required: "Email is required" })}  type="email" required placeholder="Test@gmail.com" id="email" value={formData.email} onChange={handleInputChange} />
            {errors.email && <span className='text-danger'>{errors.email.message}</span>}
          </FormGroup>
          <FormGroup>
            <Col><Label>{Password}</Label></Col>
            <div className="form-input position-relative">
              <Input {...register("password", { required: "Password is required" })}  type={isPasswordVisible ? "text" : "password"} name="login[password]" autoComplete="off" required placeholder="*********" id="password" value={formData.password} onChange={handleInputChange} />
              {errors.password && <span className='text-danger'>{errors.password.message}</span>}
              <div className="show-hide" onClick={toggle}>
                <span className={!isPasswordVisible ? "show" : ""}></span>
              </div>
            </div>
          </FormGroup>
          <div className="mb-0 form-group">
            <div className="checkbox p-0">
              <Input id="checkbox1" type="checkbox" checked={formData.checkbox1} onChange={handleInputChange} />
              <Label className="text-muted" htmlFor="checkbox1">{RememberPassword}</Label>
            </div>
            <Link className="link" to={routes.Auth.Recovery.ForgetPassword}>{ForgotPassword}</Link>
            <div className="text-end mt-3">
              <Button color="primary" block className="w-100">{SignIn}</Button>
            </div>
          </div>
          {/* <SocialLinks /> */}
        </Form>
      </div>
    </div>
  );
};
export default LoginForm;
